import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5454f49b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5454f49b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454f49b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5454f49b')) {
      api.createRecord('5454f49b', component.options)
    } else {
      api.reload('5454f49b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5454f49b&scoped=true&", function () {
      api.rerender('5454f49b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/newProject/dashboard/index.vue"
export default component.exports